import React from 'react';

const TOYS = {
  doll: (
    <svg viewBox="0 0 90 110" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
      {/* Hair */}
      <ellipse cx="45" cy="22" rx="26" ry="26" fill="#FFD600" stroke="#111" strokeWidth="3"/>
      <rect x="19" y="22" width="8" height="22" rx="4" fill="#FFD600" stroke="#111" strokeWidth="2.5"/>
      <rect x="63" y="22" width="8" height="22" rx="4" fill="#FFD600" stroke="#111" strokeWidth="2.5"/>
      {/* Head */}
      <circle cx="45" cy="26" r="22" fill="#FFDAB9" stroke="#111" strokeWidth="3"/>
      {/* Eyes */}
      <circle cx="37" cy="22" r="4" fill="#111"/>
      <circle cx="53" cy="22" r="4" fill="#111"/>
      <circle cx="38.5" cy="20.5" r="1.5" fill="white"/>
      <circle cx="54.5" cy="20.5" r="1.5" fill="white"/>
      {/* Rosy cheeks */}
      <ellipse cx="30" cy="28" rx="5" ry="3.5" fill="#FF8A80" opacity="0.7"/>
      <ellipse cx="60" cy="28" rx="5" ry="3.5" fill="#FF8A80" opacity="0.7"/>
      {/* Smile */}
      <path d="M38 32 Q45 38 52 32" fill="none" stroke="#111" strokeWidth="2.5" strokeLinecap="round"/>
      {/* Dress body */}
      <path d="M24 46 L18 98 L72 98 L66 46 Z" fill="#FF69B4" stroke="#111" strokeWidth="3" strokeLinejoin="round"/>
      {/* Dress collar */}
      <path d="M33 46 Q45 54 57 46" fill="#FF9EC8" stroke="#111" strokeWidth="2.5" strokeLinecap="round"/>
      {/* Dress hem ruffle */}
      <path d="M18 98 Q27 90 36 98 Q45 90 54 98 Q63 90 72 98" fill="none" stroke="#111" strokeWidth="2.5" strokeLinecap="round"/>
      {/* Arms */}
      <ellipse cx="14" cy="62" rx="7" ry="16" fill="#FFDAB9" stroke="#111" strokeWidth="2.5" transform="rotate(10 14 62)"/>
      <ellipse cx="76" cy="62" rx="7" ry="16" fill="#FFDAB9" stroke="#111" strokeWidth="2.5" transform="rotate(-10 76 62)"/>
      {/* Legs */}
      <rect x="30" y="96" width="12" height="14" rx="5" fill="#FFDAB9" stroke="#111" strokeWidth="2.5"/>
      <rect x="48" y="96" width="12" height="14" rx="5" fill="#FFDAB9" stroke="#111" strokeWidth="2.5"/>
      {/* Shoes */}
      <ellipse cx="36" cy="110" rx="8" ry="5" fill="#EF2323" stroke="#111" strokeWidth="2.5"/>
      <ellipse cx="54" cy="110" rx="8" ry="5" fill="#EF2323" stroke="#111" strokeWidth="2.5"/>
    </svg>
  ),

  balloon: (
    <svg viewBox="0 0 80 110" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
      {/* Balloon body */}
      <ellipse cx="40" cy="44" rx="32" ry="38" fill="#FFD600" stroke="#111" strokeWidth="3.5"/>
      {/* Shine */}
      <ellipse cx="28" cy="26" rx="8" ry="10" fill="rgba(255,255,255,0.45)"/>
      {/* Knot */}
      <path d="M36 82 Q40 88 44 82" fill="none" stroke="#111" strokeWidth="3" strokeLinecap="round"/>
      {/* String */}
      <path d="M40 87 Q44 95 40 104 Q36 110 40 108" fill="none" stroke="#111" strokeWidth="2.5" strokeLinecap="round"/>
    </svg>
  ),

  ball: (
    <svg viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
      <circle cx="45" cy="45" r="40" fill="white" stroke="#111" strokeWidth="3.5"/>
      {/* Stripes */}
      <path d="M5 45 Q25 20 45 45 Q65 70 85 45" fill="none" stroke="#EF2323" strokeWidth="8"/>
      <path d="M5 45 Q25 70 45 45 Q65 20 85 45" fill="none" stroke="#2196F3" strokeWidth="8"/>
      <path d="M45 5 Q20 25 45 45 Q70 65 45 85" fill="none" stroke="#4CAF50" strokeWidth="8"/>
      <circle cx="45" cy="45" r="40" fill="none" stroke="#111" strokeWidth="3.5"/>
      {/* Shine */}
      <ellipse cx="30" cy="25" rx="8" ry="7" fill="rgba(255,255,255,0.55)"/>
    </svg>
  ),

  teddybear: (
    <svg viewBox="0 0 100 110" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
      {/* Ears */}
      <circle cx="25" cy="22" r="14" fill="#A0522D" stroke="#111" strokeWidth="3"/>
      <circle cx="25" cy="22" r="8"  fill="#D2691E"/>
      <circle cx="75" cy="22" r="14" fill="#A0522D" stroke="#111" strokeWidth="3"/>
      <circle cx="75" cy="22" r="8"  fill="#D2691E"/>
      {/* Head */}
      <circle cx="50" cy="38" r="28" fill="#A0522D" stroke="#111" strokeWidth="3.5"/>
      {/* Snout */}
      <ellipse cx="50" cy="48" rx="12" ry="9" fill="#D2691E" stroke="#111" strokeWidth="2.5"/>
      {/* Nose */}
      <ellipse cx="50" cy="44" rx="5" ry="3.5" fill="#5D2E0C"/>
      {/* Smile */}
      <path d="M44 51 Q50 57 56 51" fill="none" stroke="#5D2E0C" strokeWidth="2.5" strokeLinecap="round"/>
      {/* Eyes */}
      <circle cx="40" cy="32" r="5" fill="#222"/>
      <circle cx="60" cy="32" r="5" fill="#222"/>
      <circle cx="42" cy="30" r="2" fill="white"/>
      <circle cx="62" cy="30" r="2" fill="white"/>
      {/* Body */}
      <ellipse cx="50" cy="82" rx="24" ry="22" fill="#A0522D" stroke="#111" strokeWidth="3.5"/>
      {/* Belly */}
      <ellipse cx="50" cy="84" rx="14" ry="14" fill="#D2691E"/>
      {/* Arms */}
      <ellipse cx="22" cy="78" rx="10" ry="16" fill="#A0522D" stroke="#111" strokeWidth="3" transform="rotate(-15 22 78)"/>
      <ellipse cx="78" cy="78" rx="10" ry="16" fill="#A0522D" stroke="#111" strokeWidth="3" transform="rotate(15 78 78)"/>
      {/* Legs */}
      <ellipse cx="36" cy="102" rx="10" ry="8" fill="#A0522D" stroke="#111" strokeWidth="3"/>
      <ellipse cx="64" cy="102" rx="10" ry="8" fill="#A0522D" stroke="#111" strokeWidth="3"/>
    </svg>
  ),
};

export default function ToyImage({ toyId, style, className }) {
  return (
    <div style={{ width: '100%', height: '100%', ...style }} className={className}>
      {TOYS[toyId] || null}
    </div>
  );
}
